export default __webpack_public_path__ + "static/heynew-fe8c4e8f531139b54f5556cd9b089b11.svg";